import React from "react";

import AllRoutes from "./routes/Routes";

//import { configureFakeBackend } from "./helpers";


// For Default import Default.scss
import "./assets/scss/Default.scss";

// For Saas import Saas.scss
// import './assets/scss/Saas.scss';

// For Modern demo import Modern.scss
// import './assets/scss/Modern.scss';

// For Creative demo import Creative.scss
// import "./assets/scss/Creative.scss";

// For Purple demo import Purple.scss
// import './assets/scss/Purple.scss';

// For Material demo import Material.scss
// import './assets/scss/Material.scss';


// Other
import "./assets/scss/Landing.scss";
import "./assets/scss/Icons.scss";
import "react-ladda-button/dist/ladda-themeless.min.css";
import "react-toastify/dist/ReactToastify.css";

// configure fake backend
//configureFakeBackend();

//query client
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "./components/ErrorBoundary";
import RouteAnalytics from "./analytics/usePageTracking";
import usePermissionRefresh from "./helpers/usePermissionRefresh";

const queryClient = new QueryClient();
const App = () => {
  // Permissions used to be learned once, from the login response, and never again — so a
  // grant made after a session started stayed invisible until the user logged out and
  // back in. Re-read them once per app load; PrivateRoute re-renders the private subtree
  // when they change.
  usePermissionRefresh();

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <React.Fragment>
          {/* GA4 SPA page-view + identity tracking (inside the Router) */}
          <RouteAnalytics />

          <AllRoutes />
          <ToastContainer />
        </React.Fragment>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
